import React, { useState } from "react";
import { updatePassword } from "aws-amplify/auth";
import { useAuth } from "../../context/AuthContext";

export default function AccountTab() {
  const { user, signOut } = useAuth();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState<{
    type: "success" | "error";
    message: string;
  } | null>(null);

  const handleChangePassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus(null);

    if (newPassword !== confirmPassword) {
      setStatus({ type: "error", message: "New passwords do not match" });
      return;
    }

    if (newPassword.length < 8) {
      setStatus({
        type: "error",
        message: "Password must be at least 8 characters",
      });
      return;
    }

    setSaving(true);

    try {
      await updatePassword({
        oldPassword: currentPassword,
        newPassword,
      });
      setStatus({ type: "success", message: "Password updated successfully" });
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      setStatus({
        type: "error",
        message: err instanceof Error ? err.message : "Failed to update password",
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <div className="settings-section">
        <h2>Account Details</h2>
        <p className="section-desc">Your personal account information</p>

        <div className="settings-form">
          <div className="form-row">
            <div className="form-group">
              <label>First Name</label>
              <input type="text" value={user?.firstName || ""} disabled />
            </div>
            <div className="form-group">
              <label>Last Name</label>
              <input type="text" value={user?.lastName || ""} disabled />
            </div>
          </div>
          <div className="form-group">
            <label>Email</label>
            <input type="email" value={user?.email || ""} disabled />
          </div>
          <div className="form-group">
            <label>Role</label>
            <input
              type="text"
              value={user?.role || ""}
              disabled
              style={{ textTransform: "capitalize" }}
            />
          </div>
        </div>
      </div>

      <div className="settings-section">
        <h2>Change Password</h2>
        <p className="section-desc">Update your account password</p>

        <form onSubmit={handleChangePassword}>
          <div className="settings-form">
            <div className="form-group">
              <label htmlFor="currentPassword">Current Password</label>
              <input
                id="currentPassword"
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                placeholder="Enter current password"
                required
                autoComplete="current-password"
              />
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="newPassword">New Password</label>
                <input
                  id="newPassword"
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="At least 8 characters"
                  required
                  minLength={8}
                  autoComplete="new-password"
                />
              </div>
              <div className="form-group">
                <label htmlFor="confirmPassword">Confirm New Password</label>
                <input
                  id="confirmPassword"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Re-enter new password"
                  required
                  minLength={8}
                  autoComplete="new-password"
                />
              </div>
            </div>

            <div className="settings-actions">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={saving}
              >
                {saving ? "Updating..." : "Update Password"}
              </button>
              {status && (
                <span className={`save-status ${status.type}`}>
                  {status.message}
                </span>
              )}
            </div>
          </div>
        </form>
      </div>

      <div className="settings-section">
        <h2>Danger Zone</h2>
        <p className="section-desc">Irreversible account actions</p>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "1rem",
            background: "#fef2f2",
            borderRadius: "8px",
            border: "1px solid #fecaca",
          }}
        >
          <div>
            <div style={{ fontWeight: 500, color: "#991b1b" }}>
              Sign out of all devices
            </div>
            <div style={{ fontSize: "0.85rem", color: "#6b7280" }}>
              This will end your current session
            </div>
          </div>
          <button
            onClick={signOut}
            className="btn"
            style={{
              background: "#dc2626",
              color: "white",
              width: "auto",
            }}
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
}
